export const setCookie = (cname: string, cvalue: any) => {
  localStorage.setItem(cname, cvalue);
  //document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookie = (cname: string) => {
  return localStorage.getItem(cname) || '';
};
